import React, { useEffect, useState } from 'react';
import { find, get, isArray, isEmpty, isFunction } from 'lodash';
import { useTranslation } from 'react-i18next';
import { format } from 'date-fns';
import { Box, Grid2 } from '@mui/material';
import ErrorIcon from '@mui/icons-material/Error';
import { ICheckEldax } from './_types';
import { Papeer } from 'components/Papeer/Papeer';
import Button from 'components/Buttons/Button';
import { useAppGlobals } from 'utils/hooks/useAppGlobals';
import { joinParams } from 'utils/study';
import { checkSignatures } from '../StudyDetail/_api';

const CheckEldax: React.FC<ICheckEldax> = ({ toggleDialog, data, studies, callback }) => {
  const { t } = useTranslation('Studies');

  const { toggleLoader } = useAppGlobals();
  const [studiesWithPdf, setStudiesWithPdf] = useState<string[]>([]);
  const [studiesWithoutPdf, setStudiesWithoutPdf] = useState<string[]>([]);

  const clearAction = () => {
    toggleDialog(false);
  };

  const confirmAction = () => {
    clearAction();
    if (isFunction(callback)) {
      callback(data, studies);
    }
  };

  const checkApi = async () => {
    toggleLoader();
    const studyIdentities = (studies || []).map((study: any) => ({
      archive: { id: get(study, 'archive.id') },
      studyInstanceUid: get(study, 'studyInstanceUid'),
    }));
    const studiesWithPdf: any[] = [];
    const studiesWithoutPdf: any[] = [];

    const response = await checkSignatures({ studies: studyIdentities });
    studies.forEach((study: any, i: number) => {
      const label = `${joinParams(
        [
          `${joinParams([
            get(study, 'patient.name.lastName', ''),
            get(study, 'patient.name.firstName', ''),
          ])}`,
          t('studyPatientId', {
            patientId: get(study, 'patient.identificationNumber', ''),
          }),
          t('studyDateBirth', {
            dateBirth: get(study, 'patient.dateBirth', false)
              ? format(new Date(study.patient.dateBirth), 'dd.MM.yyyy')
              : '',
          }),
          t('studySeriesImages', {
            series: get(study, 'numberOfStudyRelatedSeries', '?'),
            images: get(study, 'numberOfStudyRelatedInstances', '?'),
          }),
          t('studyDateTime', {
            dateTime: get(study, 'dateTime', false)
              ? format(new Date(study.dateTime), 'dd.MM.yyyy, HH:mm:ss')
              : '',
          }),
        ],
        ' | ',
      )}`;
      const checkedItem = find(isArray(response) ? response : [], (item) => {
        return (
          get(item, 'studyInstanceUid', 0) === get(study, 'studyInstanceUid', 1) &&
          item.archive.id === study.archive.id
        );
      });

      if (get(checkedItem, 'inTrustedArchive', false)) {
        studiesWithPdf.push(label);
      } else {
        studiesWithoutPdf.push(label);
      }
    });

    setStudiesWithPdf(studiesWithPdf);
    setStudiesWithoutPdf(studiesWithoutPdf);

    toggleLoader(false);
  };
  useEffect(() => {
    checkApi();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [studies]);
  return (
    <>
      <Papeer>
        <Grid2 container={true} alignItems="flex-end">
          <Grid2 size={12}>
            {!isEmpty(studiesWithPdf) && (
              <>
                <div>{t(isEmpty(studiesWithoutPdf) ? 'allStudiesWithPdf' : 'studiesWithPdf')}</div>
                {!isEmpty(studiesWithoutPdf) && (
                  <ul>
                    {studiesWithPdf.map((item: any, i: number) => (
                      <li key={i}>{item}</li>
                    ))}
                  </ul>
                )}
              </>
            )}
            {!isEmpty(studiesWithoutPdf) && (
              <>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {t(isEmpty(studiesWithPdf) ? 'allStudiesWithoutPdf' : 'studiesWithoutPdf')}
                  <ErrorIcon />
                </Box>
                {!isEmpty(studiesWithPdf) && (
                  <ul>
                    {studiesWithoutPdf.map((item: any, index: number) => {
                      return <li key={index}>{item}</li>;
                    })}
                  </ul>
                )}
              </>
            )}
          </Grid2>

          <Grid2 size={12}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
                displayPrint: 'none',
              }}
            >
              <Button onClick={clearAction} variant="contained" color="inherit" sx={{ mr: 1 }}>
                {t('close')}
              </Button>
              <Button variant="contained" color="primary" onClick={confirmAction}>
                {t('confirm')}
              </Button>
            </Box>
          </Grid2>
        </Grid2>
      </Papeer>
    </>
  );
};

export default CheckEldax;
